module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Tente novamente","description":"Não foi possível cadastrar a afiliação."},"en-US":{"title":"Try again","description":"Could not register the affiliation."}}')
  delete Component.options._Ctor
}
